export const enum LoadingStatus {
  Idle = `idle`,
  Success = `success`,
  Failed = `failed`,
  Pending = `pending`,
}

export const enum SharingAccessType {
  Viewer = `Viewer`,
  Editor = `Editor`,
  SuperAdmin = `Super Admin`,
  None = `None`,
}
